import classnames from 'classnames';
import type { FC } from 'react';
import React, { useContext } from 'react';

import { getTextDirection } from './../../../../../ricos-content/index.js';
import {
  RicosNodeContext,
  RicosNodeContextProvider,
  RicosViewerContext,
} from './../../../../../ricos-context/index.js';
import type { Node } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../../../../ricos-types/index.js';

import indentStyle from '../../../../statics/indentation-scss.js';
import Anchorable from '../../utils/Anchorable.js';
import { getPaywallSeoClass, isPaywallSeo } from '../../utils/paywallSeo.js';
import { alignmentToFlex, indentLevelToClassName } from '../consts.js';
import styles from './blockquote-scss.js';

const Blockquote: FC<NodeViewRendererProps> = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { seoMode } = useContext(RicosViewerContext);
  const { parentNode } = useContext(RicosNodeContext);
  const { indentation = 0 } = node.blockquoteData || {};
  const firstChild = node.nodes?.[0];
  const dataProperty = `${firstChild?.type?.toLowerCase()}Data`;
  const { textAlignment } =
    (firstChild?.[dataProperty as $TSFixMeKey<Node>] as $TSFixMe)?.textStyle || {};

  const indentClassName: string | undefined =
    indentLevelToClassName[indentation as keyof typeof indentLevelToClassName];

  const BlockquoteClassName = classnames(
    styles.quote,
    indentation > 0 && indentStyle[indentClassName],
    !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex)
  );
  const childClassName = styles.child;

  return (
    <Anchorable nodeId={node.id}>
      <div
        className={styles.quoteContainer}
        style={{
          justifyContent: alignmentToFlex[textAlignment as $TSFixMeKey<typeof alignmentToFlex>],
        }}
        dir={getTextDirection(node.nodes?.[0]?.nodes?.[0]?.textData?.text) || 'ltr'}
      >
        <blockquote className={BlockquoteClassName} style={node.style}>
          <span className={childClassName}>
            <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
              <RicosNodesRenderer nodes={node.nodes ?? []} />
            </RicosNodeContextProvider>
          </span>
        </blockquote>
      </div>
    </Anchorable>
  );
};

const BlockquoteRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <Blockquote key={node.id} node={node} {...props} />;
};

export default BlockquoteRenderer;
